import { JdSeatState } from "../../component/jd_seat_state_component";
import { JdTableViewComponent } from "../../component/jd_table_component";
import JdSidePotEffect from "../../component/jd_sidePot_effect";
import JdAtlasHandleComp from "../../component/jd_atlas_component";
import { JdConst } from "../../data/jd_define";
import { JdPokerComponent } from "../../component/jd_poker_component";
import { JdHelp } from "../../help/jd_help";
import LanguageManager from "../../../../../../manager/language_manager";
import JdSound from "../../../jd_sound";
import { Jd } from "../../../../net/proto/proto_jd_game";
import TexasAnimEffect from "../../../../../texasholdem/module/table/component/texas_animation_effect";
import { Card } from "../../../../../table/module/poker_table/poker_table_common";
import { PokerCommonColor } from "../../../../../k9/module/table/component/poker_com_color";
import TablePokerBase from "../../../../../table/module/table_base/table_poker_base";

export class JdTableView{

    tabViewComp:JdTableViewComponent;

    //座椅
    seatPrefab:cc.Node;

    //任务信息预设
    seatPlayerPrefab:cc.Node;

    //座位根节点
    seatRoot:cc.Node;

    //当前牌桌节点
    tableRoot:cc.Node;

    Init(root:cc.Node){
        this.tableRoot = root;
        this.seatRoot = cc.find('seatRoot',this.tableRoot);
        this.tabViewComp = this.tableRoot.getComponent(JdTableViewComponent);
        this.seatPrefab = this.tabViewComp.seatPrefab;
        this.seatPlayerPrefab = this.tabViewComp.seatPlayerPrefab;
        for (let cf of this.twoCardsEffect) {
            cf.init();
        }
        this.onInit();
    }


    get seatInfo():JdSeatState[]{
        return this.tabViewComp.seatState;
    }

    get pokerPrefab():cc.Node{
        return this.tabViewComp.pokerPrefab;
    }

    get sidePool():JdSidePotEffect{
        return this.tabViewComp.sidePool;
    }

    get dealerNode():cc.Node{
        return this.tabViewComp.dealerNode;
    }

    get checkBetNode():cc.Node{
        return this.tabViewComp.checkBetNode;
    }

    get dealer():cc.Node{
        return this.tabViewComp.dealer;
    }

    //设置盲注
    tableDes(room:number,min:number){
        this.tabViewComp.blindsLab.string = 'เดิมพันต่ำสุด' + ':' + min;
    }

    get chatNode():cc.Node{
        return this.tabViewComp.chatNode;
    }

    get twoHands(){
        return this.tabViewComp.meHands;
    }

    get twoCardsEffect(){
        return this.tabViewComp.twoCardsEffect;
    }

    get mainNode():cc.Node{
        return this.tabViewComp.mainNode;
    }

    get addBet():cc.Node{
        return this.tabViewComp.addBet;
    }
    
    get heguan():cc.Node{
        return this.tabViewComp.heguan;
    }

    get myTypeNode():cc.Node{
        return this.tabViewComp.myTypeNode;
    }

    get patternMask(){
        return this.tabViewComp.patternMask;
    }

    get handEffect(){
        return this.tabViewComp.handEffect;
    }

    get addAnim():TexasAnimEffect{
        return this.tabViewComp.addAnim
    }

    updatePoker(uid:number){
        let pokerBaseList = this.tabViewComp.pokerControl.getComponentsInChildren(TablePokerBase);
        if (pokerBaseList) {
            pokerBaseList.forEach((pokerBase)=>{
                pokerBase.uid = uid;
                pokerBase.onUpdateBack();
            });
        }
    }

    setSeatNumb(numb:number){
        this.tabViewComp.setSeatNumb(numb);
    }

    setPatternMask(isShow:boolean){
        this.patternMask.active = isShow;
    }

    //我方弃牌,执黑
    maskMyCards(){
        for (let hand of this.tabViewComp.meHands) {
            if (hand.code != 0) {
                hand.blackPoker();
            }
        }
    }

    // setMaxCardsTip(maxCardsInfo:any){
    //     if (maxCardsInfo == undefined) {
    //         return;
    //     }
    //     let node = this.tabViewComp.maxCardsDes;
    //     let pattern = this.tabViewComp.patternCard;
    //     let atlasComp = node.getComponent(JdAtlasHandleComp);
    //     let cardsArray = [];
    //     let patternComp = pattern.getComponent(JdAtlasHandleComp);
    //     for (let c of maxCardsInfo.maxCards) {
    //         let card = Card.codeToIndex(c)
    //         cardsArray.push('pubilc_' + card);
    //     }
    //     atlasComp.fillSprites(cardsArray);
    //     patternComp.fillSprites([JdConst.PokerDes[maxCardsInfo.maxCardsType]])
    // }


    //更新边池,展示
    updateSidePot(data:Jd.IBetPool[]){
        if (data && data != undefined) {
            this.sidePool.updateSidePot(data);
        }
    }

    showHandCards(cards:number[]){
        let sp:PokerCommonColor[] = this.tabViewComp.meHands;
        for (let idx = 0; idx < cards.length; idx++) {
            sp[idx].code = cards[idx];
            sp[idx].showPoker();
        }
    }

    showShowPokerOnly(cards:number[]){
        let sp:PokerCommonColor[] = this.tabViewComp.meHands;
        for (let idx = 0; idx < cards.length; idx++) {
            sp[idx].showCardOnly();
        }
    }

    updateCountDwon(numb:number){
        let countNode = this.tabViewComp.countDownNode.getChildByName('numb');
        let des = LanguageManager.t(JdConst.OpTips[6]).format(numb);
        JdHelp.setNodeString(countNode,des);
    }

    //显示牌型
    showCardsType(cardType:number,cardPoint:number){
        cc.log('->>>>cardTye cardPoint: ',cardType,cardPoint);
        if (cardType > 6) {
            cc.error('牌型类型错误:',cardPoint);
            return;
        }
        let str = '0';
        if (cardType == 1) {//牌型类型是单牌，看点数
            str = cardPoint.toString();
        }else{
            str = 'public_' + cardType;
        }

        let node = this.tabViewComp.myTypeNode
        let atlas = node.getComponent(JdAtlasHandleComp);
        atlas.fillSprites([str]);
        this.myTypeNode.active = true;
        // let strNode = this.tabViewComp.cardPattern
        // JdHelp.setNodeString(strNode,LanguageManager.t(JdConst.LocalPattern[typeID]));
        // this.myTypeNode.active = true;
    }

    setPotNumb(numb:number){
        numb = JdHelp.getRightMount(numb);
        this.showPot(numb > 0);
        if (numb > 0) {
            let lab = this.mainNode.getChildByName('numb');
            let bet = JdHelp.addThousands(numb);
            let des = LanguageManager.t(JdConst.OpTips[4]) + ':' + bet;
            JdHelp.setNodeString(lab,des);
        }
    }

    //定时调用
    updateBetAnim(isplay:boolean){
        if (isplay) {
            this.playAnim();
        }else{
            this.stopAnim();
        }
    }

    playbtn:boolean = false;
    isPlayAnim:boolean = true;//是否载播放动画
    private playAnim(){
        if (this.isPlayAnim) {
            return;
        }
        this.isPlayAnim = true;
        this.addAnim.playAnim(0);
        this.playbtn = true;
        this.tabViewComp.heguan.stopAllActions();
        JdHelp.schedule(this.tabViewComp.heguan,()=>{
            this.playbtn = !this.playbtn;
            if (this.playbtn) {
                this.addAnim.playAnim(0)
            }else{
                this.addAnim.stopAnim(0);
            }
        },5)
    }
    private stopAnim(){
        if (!this.isPlayAnim) {
            return;
        }
        this.tabViewComp.heguan.stopAllActions();
        this.addAnim.stopAnim(0);
        this.isPlayAnim = false;
    }

    showPot(isShow:boolean){
        this.mainNode.active = isShow;
    }

    setHandState(isShow:boolean){
        this.tabViewComp.mhandNode.active = isShow;
        if (!isShow) {//弃牌使用
            this.myTypeNode.active = false;
        }
    }

    //添加座椅
    addSeat(index:number):cc.Node{
        let target = this.tabViewComp.seatState[index];
        let seatNode:cc.Node = null;
        if (target) {
            seatNode = JdHelp.AddChild(this.seatPrefab,target.node)
            seatNode.name = index.toString();
        }
        return seatNode;
    }

    //手牌移动
    pokersMove(idx:number,toNode:cc.Node,comp?:Function){
        let hand = this.twoHands[idx];

        if (!hand) {
            return;
        }

        let handNode = hand.node;
        let worldPos = toNode.parent.convertToWorldSpaceAR(toNode.position);
        let localPos = handNode.parent.convertToNodeSpaceAR(worldPos);

        let time = 0.1;
        let moveTo = cc.moveTo(time,localPos);
        let scalTo = cc.scaleTo(time,0.9);
        let func = cc.callFunc(()=>{
            if (comp) {
                comp();
            }
            hand.hide();
        })
        handNode.stopAllActions()
        let spawn = cc.spawn(moveTo,scalTo);
        handNode.runAction(cc.sequence(spawn,func));
    }

    isShowSeekPlayer(isShow:boolean){
       
    }

    isShowCountDown(isShow:boolean){
        this.tabViewComp.countDownNode.active = isShow
    }

    onInit(){
        this.reset();
        this.isShowSeekPlayer(true);//默认显示
        this.stopAnim();
    };

    reset(){
        this.setPatternMask(false);
        if (this.twoHands) {
            this.twoHands.forEach((e:PokerCommonColor)=>{
                e.reset();
                e.stopPokerAction();
                e.code = 0;
            })
        }
        if (this.sidePool) {
            this.sidePool.reset();
        }
        if (this.tableRoot) {
            this.tableRoot.stopAllActions();
        }
        if (this.mainNode) {
            this.mainNode.active = false;
        }

        if (this.myTypeNode) {
            this.myTypeNode.active = false;
        }
        if (this.tabViewComp.countDownNode) {
            this.tabViewComp.countDownNode.active = false
        }
        this.setHandState(false);
        this.isShowSeekPlayer(false);
    }

    //恢复手牌默认位置
    resumeHands(cards:number[]){
        for (let idx = 0; idx < cards.length; idx++) {
            let hand = this.twoHands[idx];
            let effecthand = this.twoCardsEffect[idx];
            effecthand.resumeHands();
            let data = this.handEffect.getTransform(cards.length,idx)
            let pos = hand.node.parent.convertToNodeSpaceAR(data.worldPos);
            let node = hand.node;
            node.position = pos;
            node.scale = data.scale;
            node.angle = data.angle;
            node.zIndex = data.zIndex-10;
            hand.showPoker();
            hand.node.stopAllActions();
        }
    }

    resetHands(){
        for (let cf of this.twoCardsEffect) {
            cf.reset();
         }
    }

    beginDealCards(haveCards:number){
        this.resetHands();
        for (let i = 0; i < haveCards; i++) {
            let card = this.twoCardsEffect[i];
            card.resumeHands();
        }
        this.setHandState(true);
    }

    //我方发牌,加翻牌动画
    dealCardsMySelf(index:number,cards:number[],isPlayGame?:boolean,comp?:Function){

        if (!cards) {
            return;
        }

   

        let hand = this.twoHands[index];
        hand.code = cards[index]
        hand.showBack();
        hand.show();
        let data = this.handEffect.getTransform(cards.length,index)
        if (!data) {
            cc.log('-->>',index,cards)
            return;
        }
        let pos = hand.node.parent.convertToNodeSpaceAR(data.worldPos);

        if (cards.length <= 2) {
            hand.node.zIndex = data.zIndex - 10;
        }else{
            hand.node.zIndex = -6;
        }


        this.twoCardsEffect[index].dealMyCardsAction(this.dealerNode,pos,data.angle,()=>{
            if (index == 2) {//发第三张牌时
                if (isPlayGame) {
                    let moveStep1 = ()=>{
                        this.dealOverCards(2,3,()=>{
                            JdHelp.delay(this.addBet,()=>{
                                if (comp) {
                                    comp();
                                }
                                let oldComp:PokerCommonColor[] = this.twoHands.concat([]);
                                oldComp.sort((a:PokerCommonColor,b:PokerCommonColor)=>{
                                    let ma = Card.codeToIndex(a.code);
                                    let mb = Card.codeToIndex(b.code);
                                    return ma-mb
                                })
      
                                this.handEffect.playerDealCardsAnimEx(this.twoHands,hand.node,oldComp,false); 
                            },0.07)
                        },isPlayGame)
                    }
    
                    let nodes = [];
                    for (let idx = 0; idx < this.twoHands.length; idx++) {
                        nodes.push( this.twoHands[idx].node)
                    }
                    this.handEffect.playerDealCardsAnim(3,nodes,moveStep1.bind(this)); 
                }
            
            }
        });


//--------------------------
        // this.twoCardsEffect[index].dealMyCardsAction(this.dealerNode,pos,data.angle,()=>{

        // });
        // if (cards.length == 3) {//发第三张牌时
        //     if (isPlayGame) {
        //         let nodes = [];
        //         for (let idx = 0; idx < this.twoHands.length; idx++) {
        //            nodes.push( this.twoHands[idx].node)
        //         }
        //         this.handEffect.playerDealCardsAnim(3,nodes);   
        //     }
        // }

    }

   //发牌结束
   dealOverCards(start:number,endNumb:number,func?:Function,isPlayGame?:boolean){
    let sound = true;
    endNumb = endNumb <= this.twoHands.length ? endNumb:this.twoHands.length
    for (let i = start; i < endNumb; i++) {
        JdHelp.rotateActionScaltoEx(this.twoHands[i].node,0.1,0.2,()=>{
            this.twoHands[i].showPoker();
            if (sound) {
                JdSound.playRotatePoker();
                sound = false;
                if (func) {
                    func();
                }
            }
        },null);
    }
}


    throwCardsAction(){
        for (let tf of this.twoCardsEffect) {
            tf.throwMySelfCardsAction(this.dealerNode)
        }
        this.myTypeNode.active = false;
    }

    clear(){
        this.sidePool.clear();
    }
}
